import { Component, Input } from '@angular/core';

import { OpenLRLocationReferencePoint } from 'app/models/openlr';
import { CbmInputStyle } from 'app/shared/input/cbm-input-style';

@Component({
  selector: 'openlr',
  templateUrl: './openlr.component.html',
  styleUrls: ['./openlr.component.scss']
})
export class OpenlrComponent {
  @Input() id: string;
  @Input() inputStyle: CbmInputStyle;
  @Input() locationReferencePoint: OpenLRLocationReferencePoint;
  // @Input() locationReferencePoint: LocationReferencePoint;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/openlr/openlr.component.ts